import React from "react";
import Footer from "./Footer";

import LeftFadeIn from "../components/animations/LeftFadeIn";
import RightFadeIn from "../components/animations/RightFadeIn";
import SlideIn from "../components/animations/SlideIn";
import FadeIn from "../components/animations/FadeIn";


const About = () => (
  <>
    <div className="hero-section1" style={{ marginBottom: "20px" }}>
      <div className="row">
        <div className="col-md-1">
        </div>
        <div className="col-md-10 hero-text">
          <h1 id="about-h1">ABOUT US</h1>

          <FadeIn>
            <div class="row">
              <div class="col-md-6">
              <p style={{fontSize: '45px', color: '#000033', fontFamily: 'Raleway', marginTop: '10px'}}> <span style={{fontWeight: 'bold'}}>WE BUILD BRIDGES <br />  BETWEEN </span> <span style={{color: '#804000'}}>COMPANIES <br /> AND CUSTOMERS</span> </p>
            </div>
              <div class="col-md-6">
                <p style={{marginTop: '25px', fontSize: '18px'}}>
                BUILDEX is a Professional Construction material platform. Here we
              will provide you only interesting content, which you will like very
              much. We're dedicated to providing you the best of Construction
              material, with a focus on dependability and vender can create
              dashboard and sell items. We're working to turn our passion for
              Construction material into a booming online website. We hope you
              enjoy our Construction material as much as we enjoy offering them to
              you.
                </p>  
              </div>
            </div>
          </FadeIn>

          
          <div className="OurStory-text">
            <RightFadeIn>
              <img className="about-img1" src="/images/about_us_1.jpg" alt="" />
            </RightFadeIn>
            <LeftFadeIn>
              <h6 id="about-h3">Company History</h6>
              <p className="storytext1">
                Our e-commerce website has been providing contractors and DIY
                enthusiasts with high-quality building materials for over 10
                years. We offer a wide range of products including lumber,
                drywall, roofing materials, concrete, and tools. Our team is made
                up of experienced professionals who are knowledgeable about
                construction materials and dedicated to providing excellent
                customer service. We have a passion for the construction industry
                and take pride in helping our customers succeed in their projects.
              </p>
            </LeftFadeIn>
          </div>

          <div className="OurStory-text">
            <LeftFadeIn>
              <img className="about-img2" src="/images/about_us_2.jpg" alt="" />
            </LeftFadeIn>
            <RightFadeIn>
              <h6 id="about-h4">Our Mission</h6>
              <p className="storytext2">
                Our mission is to make it easy for customers to find and purchase
                the best quality building materials at competitive prices, while
                also offering expert advice and support. We are proud to have
                received several industry awards for our outstanding products and
                customer service. In addition, we have received positive reviews
                from satisfied customers who have purchased from our website. We
                strive to exceed our customers' expectations and build long-term
                relationships with them. We offer a 100% satisfaction guarantee
                and have a hassle-free returns policy. 
              </p>
            </RightFadeIn>
          </div>
        </div>
        <div className="col-md-2"></div>
      </div>
    </div>
    <Footer />
  </>
);
export default About;
